import { CalendarDays } from 'lucide-react';

import { cn } from '../lib/cn';

/**
 * A date field.
 *
 * Exists because the two places that have one — the reporting period popover
 * and the promotion reschedule dialog — both got the same two platform problems
 * wrong, twice over, and a shared control is the only way they stay fixed
 * together.
 *
 * The sizing half is in `styles/index.css`: on a touch screen the native
 * appearance is dropped, because WebKit on iOS otherwise measures the control as
 * `content-box` and the field renders its own padding wider than its container.
 *
 * This is the other half. With the native chrome gone there is no picker
 * indicator, and iOS never drew one to begin with, so a field showing "22 Oct
 * 2025" is indistinguishable from a read-only line of text. The glyph is drawn
 * only where the platform draws none, and it does not take pointer events: on a
 * phone the whole field opens the picker, and on a desktop the browser's own
 * indicator is still there and still the thing that opens it.
 */
export function DateInput({
  className,
  ...props
}: React.InputHTMLAttributes<HTMLInputElement>): React.JSX.Element {
  return (
    <div className="relative">
      <input type="date" className={cn('qs-date-input', className)} {...props} />
      <CalendarDays
        size={14}
        aria-hidden
        className="qs-date-affordance pointer-events-none absolute top-1/2 right-2.5 -translate-y-1/2 text-ink-faint"
      />
    </div>
  );
}
